import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
// Small fixed badge indicating the build tool (vite/webpack)
export const BuildToolBadge: React.FC = () => {
  if (commonUtils.EnvUtils.isCustomerFacing()) return null;

  const style: React.CSSProperties = {
    position: 'fixed',
    bottom: '6px',
    right: '6px',
    padding: '2px 6px',
    borderRadius: '4px',
    background: BUILD_TOOL === 'vite' ? '#7c3aed' : '#2d3748',
    color: '#ffffff',
    fontSize: '10px',
    fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    opacity: 0.6,
    zIndex: 9999,
    pointerEvents: 'none',
  };

  const prHref = BUILD_VERSION
    ? `https://github.com/finleytechnologies/atlas/search?q=${BUILD_VERSION}&type=pullrequests`
    : undefined;

  return (
    <div style={style}>
      {BUILD_VERSION ? (
        // Show short hash but link to PR(s) that include this commit on GitHub
        <a
          href={prHref}
          target="_blank"
          rel="noopener noreferrer"
          title={BUILD_VERSION}
          style={{
            color: 'inherit',
            textDecoration: 'underline',
            pointerEvents: 'auto',
          }}
        >
          {String(BUILD_VERSION).slice(0, 7)}
        </a>
      ) : (
        'unknown'
      )}
    </div>
  );
};
